/*
 * Module for the workflow conditional group/user dependent dropdowns.
*/

rs.module("controls/workflow/conditionalgroupuserlist",

    ["common/visibility"],

    function (visibility) {

        //
        // Initialize
        //
        function initialize(jsSelectors, subjectTypes) {
            // When the group changes, reload the dependent dropdown of users
            $.js(jsSelectors.subjectType, { multiple: true }).change(function () {

                var subjectType = $(this).val();

                // show and hide sections by subject type
                visibility.setVisible($.js(jsSelectors.userSection), subjectType == subjectTypes.user);
                visibility.setVisible($.js(jsSelectors.groupSection), subjectType == subjectTypes.group);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);